module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "btn",
    class: _vm.estiloBotao,
    attrs: {
      "type": '' ? 'button' : _vm.tipo,
      "data-toggle": _vm.toggle,
      "data-target": _vm.target,
      "data-dismiss": _vm.dismiss,
      "disabled": _vm.disabled
    },
    on: {
      "click": function($event) {
        return _vm.dispara()
      }
    }
  }, [_c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.iconeDireita),
      expression: "!iconeDireita"
    }],
    staticClass: "fa",
    class: _vm.iconeBotao
  }), _vm._v("\n  " + _vm._s(_vm.rotulo) + "\n  "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.iconeDireita),
      expression: "iconeDireita"
    }],
    staticClass: "fa",
    class: _vm.iconeBotao
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5daace12","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/botao/index.vue
// module id = 6wME
// module chunks = 5